import { format } from 'util';

import config from '../config';
import BaseAPIService from './BaseAPIService';

const ENDPOINTS = {
  GET_KIOSK: '/kiosk'
};

class KioskService extends BaseAPIService {
  get = address =>
    this.apiClient.get(format(ENDPOINTS.GET_KIOSK, address), {
      baseURL: config.kioskApiUrl
    });
}

export default new KioskService();
